module.exports = function clearStyles(overlayElement, wrapperElement) {
    wrapperElement.style.left = '0';
    wrapperElement.style.top = '0';
    overlayElement.classList.remove('modalPresenter-active');
    wrapperElement.classList.remove('modalPresenter-active');
}
